import {useContext} from "react";
import store from "../store"

export function useRules(){
    const {state:{Auth:{profile}}} = useContext(store);
    const {operator} = profile;
    const isAdmin = profile?.username==='admin'
    var rules;
    if(!operator) rules = []
    else rules = operator?.rules || [];
    const _rules = rules.map(rule=>rule.slug)
    
    function hasRule(rule){
        // return true;
        if(profile.username==='admin') return true
        return _rules.includes(rule)
    }
    

    return [rules,hasRule,isAdmin];
}
export default useRules;